export default {
  rootDomain: 'godaddy.com',
  resellerRootDomain: 'secureserver.net',
  olaApiHost: 'https://api.ola.{rootDomain}',
  olaApiVersionPath: '/v{version}',
  olaApiAccountsPath: '/accounts/{websiteId}',
  olaProvisioningHost: 'https://api.ola.{rootDomain}/accounts',
  securepayApiHost: 'https://securepay.{rootDomain}/api/apps/ola/accounts/{websiteId}'
};
